import { Button, Typography } from '@braskai/ui-kit';
import { useNavigate } from 'react-router-dom';

import { Stack } from '@mui/material';

import { SomethingWrongError } from '@/widgets/error';

import { useIsSpaceOwner } from '@/features/teamspace';

import { useUserBalanceStore } from '@/entities/balance';
import { useGetSpaceCredits } from '@/entities/teamspace';
import { UsageBar } from '@/entities/user/currentUser';

import { PATHS } from '@/shared/constants/routes/paths';
import { useInterfaceLanguage } from '@/shared/i18n';
import { Loader } from '@/shared/ui/Loader';

type UsageProps = {
  teamspaceId: string;
  onClose?: () => void;
};

export const UsageView = ({ teamspaceId, onClose }: UsageProps) => {
  const { t } = useInterfaceLanguage();
  const navigate = useNavigate();

  const {
    data: spaceCredits,
    isError: isErrorSpaceCredits,
    isPending: isLoadingSpaceCredits,
  } = useGetSpaceCredits(teamspaceId);

  const { hasEnterprisePlan } = useUserBalanceStore();

  const isOwner = useIsSpaceOwner();

  const navigateToSettings = () => {
    onClose?.();
    navigate(`/${PATHS.account}`);
  };

  return (
    <Stack
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'space-between',
        position: 'relative',
      }}
    >
      {isLoadingSpaceCredits && <Loader />}

      {isErrorSpaceCredits && <SomethingWrongError flex={1} />}

      {!isLoadingSpaceCredits && !isErrorSpaceCredits && (
        <>
          <Stack gap={8}>
            <UsageBar
              label={t('teamspace.usage.minutes')}
              total={spaceCredits?.credits?.minutes.total || 3}
              type="min"
              used={spaceCredits?.credits?.minutes.used || 0}
            />
            <Typography color="grey.500" variant="body-2">
              {t('teamspace.usage.description')}
            </Typography>
          </Stack>

          {isOwner && !hasEnterprisePlan && (
            <Button
              data-testid="usage-view-manage-subscription"
              size="lg"
              variant="outlined"
              fullWidth
              onClick={navigateToSettings}
            >
              {t('teamspace.usage.manageSubscription')}
            </Button>
          )}
        </>
      )}
    </Stack>
  );
};
